import { ApiProperty } from '@nestjs/swagger'
import {
  IsArray,
  ArrayNotEmpty,
  IsUUID,
  IsOptional,
  IsDateString,
  IsInt,
  Min,
  IsBoolean,
} from 'class-validator'
import { Type } from 'class-transformer'

export class BulkUsersAssignmentDto {
  @ApiProperty({
    description: "UUID de l'activité",
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsUUID('4')
  activityId!: string

  @ApiProperty({
    description: 'Liste des utilisateurs à assigner',
    type: [String],
  })
  @IsArray()
  @ArrayNotEmpty()
  @IsUUID('4', { each: true })
  userIds!: string[]

  @ApiProperty({
    description: 'Date de disponibilité (ISO 8601)',
    required: false,
  })
  @IsOptional()
  @IsDateString()
  availableFrom?: string

  @ApiProperty({ description: "Date d'échéance (ISO 8601)", required: false })
  @IsOptional()
  @IsDateString()
  dueAt?: string

  @ApiProperty({ description: 'Nombre maximum de tentatives', required: false })
  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  maxAttempts?: number

  @ApiProperty({
    description: 'Afficher les solutions après soumission',
    required: false,
  })
  @IsOptional()
  @IsBoolean()
  showSolutions?: boolean
}
